<template>
  <div>
    <cbs-objects-tbl
      meta-filter="report"
      title="REPORTS"
    />
  </div>
</template>

<script>
import CbsObjectsTbl from '@/cubus/components/objects/CbsObjectsTbl.vue'
import useCubus from '@/cubus/services/useCubus'

export default {
  name: 'CbsObjectsReport',
  components: {
    CbsObjectsTbl,
  },
  created() {
    useCubus.setPageTitle('Reports')
  },
}
</script>

<style scoped>

</style>
